import { TableBody as NovaTableBody, TableBodyProps as NovaTableBodyProps } from '@fme-nova/components'
import { default as MuiTableBody, TableBodyProps as MuiTableBodyProps } from '@mui/material/TableBody'

import { createComponentWrapperWithRef } from '../../theme'

export const TableBody = createComponentWrapperWithRef<MuiTableBodyProps | NovaTableBodyProps>(
  {
    mui: MuiTableBody,
    nova: NovaTableBody,
  },
  'TableBody',
)
